/**
 * Creates a new EquipmentCalibrationCalendarController.
 * @class
 */
class EquipmentCalibrationCalendarController {
    constructor($ngRedux, $state, $mdDialog, NavigationService, Notifier, EquipmentCalibrationActions) {
        this.$ngRedux = $ngRedux;
        this.$state = $state;
        this.$mdDialog = $mdDialog;
        this.NavigationService = NavigationService;
        this.Notifier = Notifier;
        this.actions = { ...EquipmentCalibrationActions };
    }

    $onInit() {
        const navConfig = this.NavigationService.getConfig(this.$state.$current);
        this.colorName = navConfig.colorName;
        this.icon = navConfig.icon;

        this.unsubscribe = this.$ngRedux.connect(this.mapState.bind(this), this.actions)(this);

        this.identifier = 'app.equipmentCalibration.manage';
        this.state = 'app.equipmentCalibration.manage.calendar';

        this.getCalendarEvents(this.equipment.id);
    }

    handleEventClick = (event) => {
        this.openEventDialog(event);
    };

    openEventDialog(event) {
        const complete = event.extendedProps && typeof event.extendedProps.complete !== 'undefined'
            ? !!event.extendedProps.complete
            : !!event.complete;
        const comment = event.extendedProps && event.extendedProps.comment
            ? event.extendedProps.comment
            : (event.comment || '');

        const eventDialogCtrl = ($scope) => {
            $scope.headerColor = this.colorName;
            $scope.event = {
                title: event.title,
                complete,
                comment
            };

            $scope.save = () => {
                this.$mdDialog.hide($scope.event);
            };

            $scope.cancel = () => {
                this.$mdDialog.cancel();
            };
        };
        eventDialogCtrl.$inject = ['$scope'];

        this.$mdDialog.show({
            controller: eventDialogCtrl,
            template: require('./dialogs/equipment-calibration-calendar-event-dialog.html'),
            parent: angular.element(document.body),
            clickOutsideToClose: true
        }).then((updatedEvent) => {
            const start = event.start && event.start.toDate ? event.start.toDate() : event.start;
            const eventId = event.id || (event.extendedProps && event.extendedProps.id);

            this.editCalendarEvent({
                id: eventId,
                title: event.title,
                start,
                complete: !!updatedEvent.complete,
                comment: updatedEvent.comment || ''
            }).then(() => {
                this.Notifier.success('Event updated');
            });
        }, angular.noop);
    }

    mapState(state) {
        return {
            equipment: state.equipmentCalibration.equipment,
            calendarEvents: state.equipmentCalibration.calendarEvents
        };
    }

    $onDestroy() {
        this.unsubscribe();
    }
}

EquipmentCalibrationCalendarController.$inject = ['$ngRedux', '$state', '$mdDialog', 'NavigationService', 'Notifier', 'EquipmentCalibrationActions'];

export const equipmentCalibrationCalendar = {
    controller: EquipmentCalibrationCalendarController,
    template: require('./equipment-calibration-calendar.html')
};

